import React from "react";
import {
  Switch,
  Route
} from "react-router-dom";
import Cookies from 'js-cookie';
import config from '../configs/config';

import NavigationPublic from "../features/navigation/ui/PublicNavigation";
import FooterPublic from "../features/navigation/ui/PublicFooter";
import Navigation from "../features/navigation/ui/PrivateNavigation";
import Footer from "../features/navigation/ui/PrivateFooter";

import GlobalHome from "../pages/page.globalhome";
import Home from "../pages/page.home";
import Login from "../pages/page.login";
import AgentRegister from "../pages/page.agentregister";
import AgencyRegister from "../pages/page.agencyregister";
import RestorePassword from "../pages/page.restorepassword";
import ForgotPassword from "../pages/page.forgotpassword";
import RestorePasswordManual from "../pages/page.restorepasswordmanual";
import DetailsFAQs from "../pages/page.detailsfaqs";
import RegisterBooking from "../pages/page.registerbooking";
import TrackRedeem from "../pages/page.trackredeem";
import Error from "../pages/page.404";
import ReservHotel from "../pages/page.reservhotel";
import Webinar from "../pages/page.webinar";

var location = window.location;

//modal news!
if(Cookies.get('modalnews') === 'close'){
    //console.log("modal set: close");
    Cookies.set('modalnews','close');
  }else{
    //console.log("modal set: open");
    Cookies.set('modalnews','open');
  }

  //default language
  if(!Cookies.get('language')) Cookies.set('language','eng');

  if(location.hostname !== 'localhost') config.basename = config.basename+'/';
  else config.basename = '/';

  var pathname = location.pathname;
  //console.log("path: "+location);

     //get lang from landing page
      var url = new URL(location);
      var lang_ = url.searchParams.get("lang");
    //get canada var if exist
      var iscanada_ = url.searchParams.get("iscanada");
      Cookies.set('iscanada',0);
      if(iscanada_ === '-1'){
        Cookies.set('iscanada',iscanada_);
      }

      var allowlanguages = ['esp','eng'];

      if(allowlanguages.indexOf(lang_) !== -1) Cookies.set('language',lang_);

  if(pathname === config.basename+'agencyregister' || pathname === config.basename+'login' || pathname === config.basename+'agentregister'){
           Cookies.set('loggedin', 'false');
           Cookies.set('UserAccessToken', '');
           Cookies.set('DeviceAccessToken', '');
           Cookies.set('FirstName', '');
           Cookies.set('CountryUser', '');

   }

function redirect(PageComponent) {
  return Cookies.get('loggedin') === 'true' ? (<PageComponent />) : (<Login />); // <Redirect to="/dashboard"/>
}

function Routes() {
  const publicContentWrapStyle = {
    paddingTop: '110px'
  };
  const isLoggedIn = Cookies.get('loggedin') === 'true';

  return (
      <div className="mr-ui flex min-h-screen flex-col bg-[#f3f5fb]">
        {isLoggedIn?<Navigation />:<NavigationPublic/>}
        <main className="flex-1" style={isLoggedIn ? null : publicContentWrapStyle}>
          <Switch>
            <Route path="/"  exact render={() => (redirect(GlobalHome))} />
            <Route path="/rewards"  exact render={() => (redirect(Home))} />
            <Route path="/login"  component={Login}  />
            <Route path="/agentregister"  component={AgentRegister} />
            <Route path="/agencyregister"  component={AgencyRegister} />
            <Route path="/restorepassword" component={RestorePassword} />
            <Route path="/forgotpassword" component={ForgotPassword} />
            <Route path="/restorepasswordmanual" component={RestorePasswordManual} />
            <Route path="/detailsfaqs"  render={() => (redirect(DetailsFAQs))} />
            <Route path="/registerbooking"  render={() => (redirect(RegisterBooking))} />
            <Route path="/trackredeem"  exact render={() => (redirect(TrackRedeem))} />
            <Route path="/reservhotel"  exact render={() => (redirect(ReservHotel))} />
            <Route path="/webinar"  exact render={() => (redirect(Webinar))} />
            <Route component={Error} />
          </Switch>
        </main>
        {isLoggedIn?<Footer />:<FooterPublic />}
      </div>
  );
}

export default Routes;
